<template>
    <main class="member-profile-page">
        <section v-if="user" class="member-profile-card">
            <div class="member-profile-identity">
                <img :src="user.portrait || defimg" @error="$event.target.src=defimg">
                <div>
                    <small class="member-profile-code">YAXUN VERIFIED ANALYST · 专家数据档案</small>
                    <div class="member-name"><h1>{{user.name}}</h1><span>认证专家</span></div>
                    <p>{{user.intro}}</p>
                    <div class="member-profile-tags"><span>独立分析</span><span>真实记录</span><span>赛后复盘</span></div>
                </div>
            </div>
            <div class="member-profile-metrics">
                <span><b>{{user.winrate}}%</b><small>近7天胜率</small></span>
                <span><b>{{user.recommend_count || 0}}</b><small>历史分析</small></span>
                <span><b>{{user.fans_count || 0}}</b><small>关注人数</small></span>
                <span><b>{{user.hot_sales || 0}}</b><small>热销场次</small></span>
            </div>
            <button v-if="user.relation == 0" class="member-follow" @click="addFollow(user.id)">＋ 关注专家</button>
            <button v-else-if="user.relation == 1" class="member-follow followed" @click="unAddFollow(user.id)">已关注</button>
            <button v-else-if="user.relation == 2" class="member-follow followed" @click="unAddFollow(user.id)">互相关注</button>
        </section>

        <div class="skeletonbx" v-if="init === true">
            <van-skeleton title row="5"></van-skeleton>
        </div>
        <template v-else>

        <section class="member-data-section member-record-section">
            <header class="member-section-head">
                <div><small>YAXUN PERFORMANCE FILE</small><h2>研判数据档案</h2></div>
                <div class="member-tabs">
                <div class="item">
                    <button :class="ftType===1?'curr':''" @click="getRate(1, ftBall)">按场</button>
                    <button :class="ftType===2?'curr':''" @click="getRate(2, ftBall)">按天</button>
                </div>
                <div class="item">
                    <button :class="ftBall===1?'curr':''" @click="getRate(ftType,1)">足球</button>
                    <button :class="ftBall===2?'curr':''" @click="getRate(ftType,2)">篮球</button>
                </div>
                </div>
            </header>
            <div class="member-record-head"><span>统计周期</span><span>真实战绩</span><span>胜率</span><span>表现趋势</span></div>
            <ul class="member-record-list" v-if="rate_list.length > 0">
                <li v-for="(c,i) in rate_list" :key="i">
                    <b class="record-period">近{{c.name}}</b>
                    <div class="record-result"><span class="sh"><b>{{c.sheng}}</b>红</span><span class="pi"><b>{{c.ping}}</b>和</span><span class="fu"><b>{{c.fu}}</b>黑</span></div>
                    <strong>{{c.sl}}%</strong>
                    <div class="record-progress" :ref="i===0?'line':''"><i :style="c.lineW"></i></div>
                </li>
            </ul>
            <div v-else class="member-empty">暂无战绩记录</div>
        </section>

        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loadmore"
                  :immediate-check="false"
                  :finished="finished"
                  finished-text="没有了"
                  :error.sync="error"
                  :error-text="list.length>0?'读取失败':''"
                  @load="loadMore">
            <section class="member-data-section member-recommend-section">
                <header class="member-section-head">
                    <div><small>YAXUN PUBLISHED RECORDS</small><h2>观点发布记录</h2></div>
                    <div class="member-tabs single-tabs">
                    <div class="item">
                        <button :class="rcBall===1?'curr':''" @click="getRecommend(1)">足球</button>
                        <button :class="rcBall===2?'curr':''" @click="getRecommend(2)">篮球</button>
                    </div>
                    </div>
                </header>
                <div class="member-recommend-head"><span>联赛 / 时间</span><span>对阵信息</span><span>赛果</span><span>推荐结论</span><span>发布状态</span></div>
                <div class="member-recommend-list" v-if="list.length > 0">
                    <router-link v-for="(c,i) in list" :key="i" :to="'/recommend/'+c.uuid" :class="'member-recommend-row ball'+c.ball">
                        <div class="recommend-meta"><b :style="{borderColor:c.color, color:c.color}">{{c.match_type}}</b><time>{{c.time}}</time></div>
                        <div class="recommend-match">
                            <span><team-badge :name="c.shangpan" :size="34"/><b>{{c.shangpan}}</b></span>
                            <em v-if="c.bifen">{{c.bifen}}</em><em v-else>VS</em>
                            <span><team-badge :name="c.xiapan" :size="34"/><b>{{c.xiapan}}</b></span>
                        </div>
                        <span :class="['recommend-result', hasSettledResult(c) ? resultClass(c) : 'result-pending']"><small>赛果</small><b>{{hasSettledResult(c) ? c.result : '待定'}}</b></span>
                        <strong class="recommend-direction">{{c.commend || '待公开'}}</strong>
                        <div class="recommend-publish"><small>{{c.create}}发布</small><span v-if="hasSettledResult(c)" :class="['member-result-entry',resultClass(c)]"><i>赛果</i><strong>{{c.result}}</strong><em>查看分析 →</em></span><b v-else-if="c.showtype == 1">待公开</b><b v-else-if="c.showtype == 2">{{c.gold}}球币查看</b><b v-else>查看完整分析 →</b></div>
                    </router-link>
                </div>
                <div v-else class="member-empty">暂无推介记录</div>
            </section>
        </van-list>
        </van-pull-refresh>

        </template>
    </main>
</template>

<script>
    import defPortrait from "../assets/images/default-analyst-v3.jpg"
    import TeamBadge from "./public/team_badge"
    export default {
        name: "member",
        components: {TeamBadge},
        data() {
            return {
                uid: null,
                user: null,
                action: 1,
                list: [],
                recommend_count: 0,
                init: true,
                loadmore: false, //是否在加载更多，当滚动到底部时自动设置为true(不需手动设置)，每次加载完都得手动设置为false，
                loadmore_error: false,
                finished: false, //是否加载完毕
                isloading: false, //是否正在读取
                error: false,     //是否读取错误，有错误自动设置为true，点击又重新读取更多（自动设置为false）
                refreshing: false,  //是否在下拉刷新
                pageIndex: 1,
                defimg: defPortrait,
                formPath: '',
                rate_list: [],

                ftType: 2,
                ftBall: 1,

                rcBall: 0,
            }
        },
        activated() {
            let uid = this.$route.params.uid   //uid
            this.uid = uid
            this.list = []
            this.rate_list = []
            this.user = null
            this.action = 1
            this.rcBall = 0
            //this.$toast.loading()
            this.onRefresh()
            window.addEventListener('scroll', this.handleHistoryScroll, {passive: true})
        },
        deactivated() {
            window.removeEventListener('scroll', this.handleHistoryScroll)
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleHistoryScroll)
        },
        methods: {
            hasSettledResult(c){
                return Number(c && c.result_id) > 1 && !!(c && c.result)
            },
            resultClass(c){
                if(c.result === '红') return 'result-red'
                if(c.result === '黑') return 'result-black'
                if(c.result === '和') return 'result-draw'
                return 'result-neutral'
            },
            handleHistoryScroll(){
                if(this.finished || this.loadmore || this.isloading || this.init || this.error) return
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
                const viewport = window.innerHeight || document.documentElement.clientHeight || 0
                const height = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
                if(scrollTop + viewport >= height - 500) this.loadMore()
            },
            loadMore() {
                let that = this
                // van-list 会在触发 @load 前先把 loadmore 设为 true，
                // 因此这里只用 isloading 防重，不能用 loadmore 拦截自身事件。
                if(that.finished || that.isloading) return
                that.isloading = true
                that.loadmore = true
                if(!that.loadmore_error)
                    that.pageIndex++
                that.getList()
            },
            onRefresh(){
                let that = this
                this.pageIndex = 1
                this.finished = false
                this.loadmore = false
                this.error = false
                this.isloading = true
                that.getList()
            },
            getList(t=0){
                let that = this
                that.loadmore_error = false
                that.$post(that.$api.member_info,{page: that.pageIndex, uid: that.uid, action: that.action, ball: that.rcBall}).then(function (res) {
                    // console.log(res)
                    if(res.code === 1) {
                        if(res.data.user) {
                            let usertmp = res.data.user
                            if (usertmp.portrait)
                                usertmp.portrait = that.$api.imgBaseUrl + usertmp.portrait
                            that.user = usertmp
                            document.title = usertmp.name + that.$get_config_text.title
                        }
                        if(res.data.rate_ball)
                            that.ftBall = res.data.rate_ball
                        if(res.data.rate_list && res.data.rate_list.length>0) {
                            that.rate_list = res.data.rate_list
                            setTimeout(()=>{
                            that.getlinewidth()
                            }, 300)
                        }
                        if(res.data.recommend_count)
                            that.recommend_count = res.data.recommend_count
                        if(res.data.recommend_list) {
                            let tmplist = res.data.recommend_list
                            if (tmplist.length > 0) {
                                tmplist.forEach(function (i) {
                                    if (i.user && i.user.portrait)
                                        i.user.portrait = that.$api.imgBaseUrl + i.user.portrait
                                })
                                if (that.refreshing || t==1)
                                    that.list = tmplist  //如果是下拉刷新则列表重置
                                else
                                    that.list = that.list.concat(tmplist)
                                if (res.data.end || tmplist.length < 15)
                                    that.finished = true
                            } else {
                                that.finished = true
                            }
                        }
                    }
                    else{
                        that.$toast.fail('读取失败')
                    }
                })
                //.catch(function () {
                //     that.$toast.fail('读取失败')
                //     console.log('catch')
                //     that.error = true
                //     that.loadmore_error = true
                // })
                .finally(function () {
                    // console.log('finally')
                    that.action = 2
                    that.init = false
                    that.loadmore = false
                    that.isloading = false
                    that.refreshing = false
                })
            },
            getRecommend(t=0){
                let that = this
                that.rcBall = t
                that.pageIndex = 1
                that.list = []
                that.finished = false
                that.error = false
                that.isloading = true
                that.getList(1)
            },
            getRate(t=1, b=1){
                let that = this
                that.ftBall = b
                that.ftType = t
                that.$post(that.$api.member_rate,{uid: that.uid, ball: that.ftBall, type: that.ftType}).then(function (res) {
                    // console.log(res)
                    if(res.code === 1) {
                        // if(res.data.rate_list.length>0) {
                            that.rate_list = res.data.rate_list
                            that.getlinewidth()
                        // }
                    }
                })
            },

            addFollow(id){
                let that = this
                that.$toast.loading()
                that.$post(that.$api.addfollow, {mid: id}).then(function (res) {
                    if(res.code === 1){
                        that.$toast.success(res.msg)
                        that.user.relation = res.data.relation
                        that.user.fans_count += 1
                    }
                    else{
                        that.$toast(res.msg)
                    }
                })
            },
            unAddFollow(id){
                let that = this
                that.$toast.loading()
                that.$post(that.$api.unaddfollow, {mid: id}).then(function (res) {
                    if(res.code === 1){
                        that.$toast.success(res.msg)
                        that.user.relation = res.data.relation
                        that.user.fans_count -= 1
                    }
                    else{
                        that.$toast(res.msg)
                    }
                })
            },
            goBack(){
                // let that = this
                // this.$router.back()
                // window.history.go(-1)
                // return
                this.$router.push({
                //     path: that.formPath === '' ?'/':that.formPath
                    path: '/'
                })
            },
            getlinewidth(){
                /**
                 * 设置胜率进度条长度
                 * @type {default.methods}
                 */
                let that = this
                that.$nextTick(() => {
                    let line = that.$refs.line
                    let width = 0
                    line.forEach((item) => {
                        width = item.offsetWidth //clientWidth
                    })
                    that.line_base_width = width
                    //更新胜率滚动条长度
                    let tmplist = that.rate_list
                    tmplist.forEach(function (i) {
                        let w = i.sl/100 * width
                        if(i.sl < 60)
                            i.lineW = 'width:'+ w +'px;background-color:#ff6600;'
                        else
                            i.lineW = 'width:'+ w +'px'
                    })
                    that.rate_list = tmplist
                })
            }
        },
        beforeRouteEnter(to, form, next){
            next(vm => {
                vm.formPath = form.path
            })
        }
    }
</script>

<style scoped>
</style>
